import * as service from './Evaluation.services'
export default {
  props: ["action"], //FG - FOOF - After Cert - First Release Security (7) - added the prop
  data() {
    return {
      labelPosition: 'top',
      isediting: false,
      EditableColID: '',
      EvaluationTypes: [],
      PerformanceLevels: [],
      personnelID: '',
      ActionTypes: [],
      Evaluations: [],
      label: 'Verified By :  ',


      addEvaluation: {

        "PersonnelId": '',
        "ReviewDate": "",
        "StartPeriod": "",
        "EndPeroid": "",
        "SupervisorComments": "",
        "EmployeeComments": "",
        "EvaluatedUserId": "",
        "EvaluatedUser": "",
        "EvaluationLevels": []


      },
      modalTitle: '',
      evalBackup: [],
      users: [],
      rules: {
        /*    EvaluationTypeId: [
         {required: true, message: 'Please select Evaluation Type'}

         ],
         PerformanceLevelId: [
         {required: true, message: 'Please select Performance Level'}

         ],
         Observation: [
         {required: true, message: 'This field is required', trigger: 'blur'},
         {min: 1, max: 1500, message: 'Length should be 1 to 1500', trigger: 'blur'}
         ],
         ActionItem: [
         {required: true, message: 'This field is required', trigger: 'blur'},
         {min: 1, max: 1500, message: 'Length should be 1 to 1500', trigger: 'blur'}
         ],
         TargetDate: [
         {type: 'date', required: true, message: 'Please pick a date', trigger: 'change'}
         ],
         FirstName: [
         {required: true, message: 'This field is required', trigger: 'blur'},
         {min: 1, max: 50, message: 'Length should be 1 to 50', trigger: 'blur'}
         ],
         LastName: [
         {required: true, message: 'This field is required', trigger: 'blur'},
         {min: 1, max: 50, message: 'Length should be 1 to 50', trigger: 'blur'}
         ],*/

      },
    }
  },
  mounted() {
    let context = this
    this.personnelID = this.$route.params.id


    this.$router.app.$on('add_eval', (data) => {

      context.addEvaluation = {

        "PersonnelId": context.personnelID,
        "ReviewDate": "",
        "StartPeriod": "",
        "EndPeroid": "",
        "SupervisorComments": "",
        "EmployeeComments": "",
        "EvaluatedUserId": "",
        "EvaluatedUser": "",
        "EvaluationLevels": []

      }
      context.GetAllEvaluationTypes()
      context.GetPerformanceLevels()
      context.GetAllusers()
      context.$refs['addEvaluation'].resetFields()
    })
    this.$router.app.$on('Evaluation_obj', (data) => {

      context.GetPerformanceLevels()
      context.GetAllusers()
      context.GetEvaluation(data)
      setTimeout(function () {
        context.GetAllEvaluationTypes()
      }, 500)


    })
    this.$router.app.$on('submit_eval', (data) => {

      context.submitForm(data)

    })

    this.$router.app.$on('update_eval', (data) => {

      context.EditEvaluation(data)

    })

    this.$router.app.$on('del_eval', (data) => {

      context.del(data)

    })

    /*this.role= JSON.parse(localStorage.getItem('authentication')).role;
     if(this.role=='AquaticsDirector'|| this.role=='PoolManager' || this.role=='AsstPoolManager' || this.role=='ToolAdmin'){
     this.Certificationcolumns=  ["ReviewDate", "Observation", "StartPeriod", "EndPeroid", "Actions"];
     }
     else{
     this.Certificationcolumns=  ["ReviewDate", "Observation", "StartPeriod", "EndPeroid"];
     }*/
  },
  beforeDestroy() {
    this.$root.$off('update_eval')
    this.$root.$off('del_eval')
    this.$root.$off('submit_eval')
    this.$root.$off('Evaluation_obj')

  },
  methods: {

    ShowAddEvaluation() {
      let context = this

      this.isediting = false
      this.modalTitle = 'Create Evaluation'
      $('#AddEvaluationmodel').modal('show')
      this.resetForm('addEvaluation')
      this.addEvaluation = deepcopy(this.evalBackup)
    },

    GetEvaluation(PersonnelId) {
      let context = this
      loader.startLoader()
      service.GetEvaluation(PersonnelId).then(function (response) {
        context.addEvaluation = []
        loader.stopLoader()
        if (response) {
          context.addEvaluation = response
        } else {
          context.addEvaluation = []
        }
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetPerformanceLevels() {
      let context = this
      loader.startLoader()
      service.GetPerformanceLevels().then(function (response) {

        context.PerformanceLevels = response
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    del: function (data) {
      var ID = data
      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteEvaluation(ID).then(function (response) {

          //FG - FOOF - After Cert - First Release Security - added conditional statement below
          if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
            loader.stopLoader()
            return;
          }

          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })
          context.$router.app.$emit('action_done')

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })
    },

    cancelpopup: function () {

      $('#AddEvaluationmodel').modal('hide')
    },

    EditEvaluation: function (data) {

      // this.$refs[formname].validate((valid) => {
      //   if (valid) {
      let context = this
      loader.startLoader()

      let evaluationData = context.addEvaluation


      var evalBack = {
        PersonnelId: context.personnelID,
        ReviewDate: context.$options.filters.fdate(context.addEvaluation.ReviewDate),
        StartPeriod: context.$options.filters.fdate(context.addEvaluation.StartPeriod),
        EndPeroid: context.$options.filters.fdate(context.addEvaluation.EndPeroid),
        EvaluatedUserId: context.addEvaluation.EvaluatedUserId,
        SupervisorComments: context.addEvaluation.SupervisorComments,
        EmployeeComments: context.addEvaluation.EmployeeComments,
        EvaluationLevels: [],
        Id: context.addEvaluation.Id
      }

      context.addEvaluation.EvaluationLevels.map(function (item) {

        if (item.PerformanceLevelId) {
          evalBack.EvaluationLevels.push(item)
        }

      })

      /*      alert(JSON.stringify(evalBack))*/

      service.UpdateEvaluation(evalBack).then(function (response) {
        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
          loader.stopLoader()
          return; 
        }

        loader.stopLoader()

        context.$notify({
          title: 'Success',
          message: 'Successfully Updated Evaluation',
          type: 'success'
        })
        context.$router.app.$emit('action_done')

      }, (error) => {

        loader.stopLoader()

        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })

    },

    GetAllusers() {
      let context = this
      loader.startLoader()
      service.GetAllusers().then(function (response) {
        context.users = response


        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },


    GetAllEvaluationTypes() {


      let context = this
      loader.startLoader()
      service.GetAllEvaluationTypes().then(function (response) {

        var sl = response
        // alert(context.addEvaluation.EvaluationLevels.length)
        if (context.addEvaluation.EvaluationLevels.length > 0) {


          response.map(function (item, index) {

            context.addEvaluation.EvaluationLevels.map(function (it, ind) {
              if ((item.Id !== it.EvaluationTypeId) && (!sl[index].Comment && !sl[index].PerformanceLevel && !sl[index].PerformanceLevelId)) {

                sl[index] = {
                  "Comment": "",
                  "EvaluationType": item.Name,
                  "EvaluationTypeId": item.Id,
                  "PerformanceLevel": "",
                  "PerformanceLevelId": '',
                  "PerformanceOrdinance": item.Ordinance

                }
              } else {
                if (item.Id == it.EvaluationTypeId) {

                  sl[index] = it
                }
              }


            })


          })
          /*  sl.sort(function (a, b) {
           return a.PerformanceOrdinance - b.PerformanceOrdinance

           });*/
          context.addEvaluation.EvaluationLevels = sl


        } else {

          response.map(function (item) {

            context.addEvaluation.EvaluationLevels.push({
              "Comment": "",
              "EvaluationType": item.Name,
              "EvaluationTypeId": item.Id,
              "PerformanceLevel": "",
              "PerformanceLevelId": '',
              "PerformanceOrdinance": item.Ordinance

            })
            context.addEvaluation.EvaluationLevels.sort(function (a, b) {
              return a.PerformanceOrdinance - b.PerformanceOrdinance

            });
          })
        }

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    editcol: function (data, buttonType) {
      alert ("editcol in Evaluation.controll.js - is this ever used ?")
      if(buttonType="view")
        this.action="V"
      else
        this.action="E"
      /*  var ID = data.row.Id;
       let context = this;
       context.EditableColID = ID;
       context.addKudos.actiondate = data.row.ActionDate;
       context.addKudos.commentedby = data.row.CommentedBy;
       context.addKudos.actiontype = data.row.ActionTypeId;
       context.addKudos.description = data.row.Description;*/

      this.resetForm('addEvaluation')
      this.isediting = true
      this.modalTitle = 'Edit Evaluation'
      $('#AddEvaluationmodel').modal('show')

      this.addEvaluation = data.row

    },

    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context = this
          loader.startLoader()

          let evaluationData = context.addEvaluation


          var evalBack = {
            PersonnelId: context.personnelID,
            ReviewDate: context.$options.filters.fdate(context.addEvaluation.ReviewDate),
            StartPeriod: context.$options.filters.fdate(context.addEvaluation.StartPeriod),
            EndPeroid: context.$options.filters.fdate(context.addEvaluation.EndPeroid),
            EvaluatedUserId: context.addEvaluation.EvaluatedUserId,
            SupervisorComments: context.addEvaluation.SupervisorComments,
            EmployeeComments: context.addEvaluation.EmployeeComments,
            EvaluationLevels: []

          }

          context.addEvaluation.EvaluationLevels.map(function (item) {

            if (item.PerformanceLevelId) {
              evalBack.EvaluationLevels.push(item)
            }

          })


          service.AddEvaluation(evalBack).then(function (response) {

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
              loader.stopLoader()
              return;
            }

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Succesfully Created Evaluation',
              type: 'success'
            })
            context.$router.app.$emit('action_done')

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'EVAL - error while submit!!',

            type: 'error'

          })

          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Evaluation/Evaluation.controller.js